import { AppPage } from '@/types/navigation';

export const ROUTES = {
  MAIN: '/',
  DASHBOARD: '/dashboard',
  CALENDAR: '/calendar',
  NOTIFICATIONS: '/notifications',
  HELP: '/help',
  SETTINGS: '/settings',
  PLACES: '/places',
  BILLING: '/billing',
  UPGRADE: '/upgrade',
  ACCOUNT: '/account',
  LOGIN: '/login',
  SIGNUP: '/signup',
  RESET_PASSWORD: '/reset-password',
  TRANSACTIONS: '/transactions',
  SUBSCRIPTIONS: '/subscriptions',
  BUDGETS_OVERVIEW: '/budgets/overview',
  BUDGETS: '/budgets',
} as const;

export const URL_TO_PAGE_MAP: Record<string, AppPage> = {
  [ROUTES.MAIN]: 'main',
  [ROUTES.DASHBOARD]: 'dashboard',
  [ROUTES.CALENDAR]: 'calendar',
  [ROUTES.NOTIFICATIONS]: 'notifications',
  [ROUTES.HELP]: 'help',
  [ROUTES.SETTINGS]: 'settings',
  [ROUTES.PLACES]: 'places',
  [ROUTES.BILLING]: 'billing',
  [ROUTES.UPGRADE]: 'upgrade',
  [ROUTES.ACCOUNT]: 'account',
  [ROUTES.LOGIN]: 'login',
  [ROUTES.SIGNUP]: 'signup',
  [ROUTES.RESET_PASSWORD]: 'reset-password',
  [ROUTES.TRANSACTIONS]: 'transactions',
  [ROUTES.SUBSCRIPTIONS]: 'subscriptions',
  [ROUTES.BUDGETS_OVERVIEW]: 'budgets-overview',
  [ROUTES.BUDGETS]: 'budgets',
};

export const PAGE_TO_URL_MAP: Record<AppPage, string> = {
  main: ROUTES.MAIN,
  dashboard: ROUTES.DASHBOARD,
  calendar: ROUTES.CALENDAR,
  notifications: ROUTES.NOTIFICATIONS,
  help: ROUTES.HELP,
  settings: ROUTES.SETTINGS,
  places: ROUTES.PLACES,
  billing: ROUTES.BILLING,
  upgrade: ROUTES.UPGRADE,
  account: ROUTES.ACCOUNT,
  login: ROUTES.LOGIN,
  signup: ROUTES.SIGNUP,
  'reset-password': ROUTES.RESET_PASSWORD,
  transactions: ROUTES.TRANSACTIONS,
  subscriptions: ROUTES.SUBSCRIPTIONS,
  'budgets-overview': ROUTES.BUDGETS_OVERVIEW,
  budgets: ROUTES.BUDGETS,
};

export const PROTECTED_PAGES: AppPage[] = [
  'dashboard',
  'calendar',
  'notifications',
  'help',
  'settings',
  'places',
  'billing',
  'upgrade',
  'account',
  'transactions',
  'subscriptions',
  'budgets-overview',
  'budgets',
];

export const isProtectedPage = (page: AppPage): boolean => {
  return PROTECTED_PAGES.includes(page);
}; 